var _path, _g, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgWebCloudPlansNg = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 48,
  height: 82,
  viewBox: "0 0 48 82",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3.84 0C1.71923 0 0 1.81929 0 4.06349V59.9365C0 62.1807 1.71923 64 3.84 64H6.96774H33.6H44.16C46.2808 64 48 62.1807 48 59.9365V4.06349C48 1.81929 46.2808 0 44.16 0H3.84Z",
  fill: "#E3E3E3"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  opacity: 0.9
}, /*#__PURE__*/React.createElement("path", {
  d: "M36 64H44V72.6667L43 76H37L36 72.6667V64Z",
  fill: "#222222"
}), /*#__PURE__*/React.createElement("path", {
  d: "M38 76H42V77H38V76Z",
  fill: "#222222"
}), /*#__PURE__*/React.createElement("path", {
  d: "M39 74H41V81H39V74Z",
  fill: "#222222"
}))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M44 52C44 54.2092 42.2092 56 40 56H5C4.44772 56 4 55.5523 4 55C4 54.4477 4.44772 54 5 54H34.4408C35.3712 54 36 52.9304 36 52C36 49.7908 37.7908 48 40 48C42.2092 48 44 49.7908 44 52ZM40 54C41.1046 54 42 53.1046 42 52C42 50.8954 41.1046 50 40 50C38.8954 50 38 50.8954 38 52C38 53.1046 38.8954 54 40 54Z"
})));
export { SvgWebCloudPlansNg as ReactComponent };